import { render, staticRenderFns } from "./PerformanceQueryPoints.vue?vue&type=template&id=00195bea&scoped=true"
import script from "./PerformanceQueryPoints.vue?vue&type=script&lang=js"
export * from "./PerformanceQueryPoints.vue?vue&type=script&lang=js"
import style0 from "./PerformanceQueryPoints.vue?vue&type=style&index=0&id=00195bea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00195bea",
  null
  
)

export default component.exports